import React, { useEffect, useState } from 'react'

import { ReasonIndicatorCard } from 'presentation/hospital/layouts/ActiveSearch/Cards/ReasonIndicatorCard'
import {
  ActiveType,
  HelpCardType,
  LoadActiveSearchStatistics
} from 'domain/usecases/active-search/load-active-search-statistics'
import { ReactComponent as CalendarRange } from 'presentation/assets/icons/calendar-range.svg'
import moment from 'moment'
import { dateInputFormat } from 'presentation/utils/date-format'
import { dateMask } from 'presentation/utils/masks'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import { toast } from 'react-toastify'
import { Props } from '@storybook/addon-docs'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import HelpRequestsIndicators from 'presentation/hospital/components/ActiveSearch/HelpRequestsIndicators'
import {
  ActiveSearchSurgeryTranslated,
  ActiveSearchSurgeryType
} from 'common/enum/active-search-surgery-type'
import { useHistory } from 'react-router-dom'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import * as S from './styles'
import { ActiveSearchHelpStatus } from 'common/enum/active-search-help-status'

type LoadActiveSearchProps = {
  headerTitle?: string
  type?: ActiveSearchSurgeryType
  status?: ActiveSearchHelpStatus
}

type Props = {
  loadActiveSearchStatistics: LoadActiveSearchStatistics
  currentHospitalId: number
} & WithLoadingProps

const ActiveSearchLayout = WithLoading(
  ({ loadActiveSearchStatistics, currentHospitalId, setIsLoading }: Props) => {
    const [activeSearchTypes, setActiveSearchTypes] = useState<any>([])
    const [helpCardInfo, setHelpCardInfo] = useState<any>({})
    const [totalActiveSearchCount, setTotalActiveSearchCount] = useState(0)

    // Refatorar esses filtros
    const [selectedStartDate, setSelectedStartDate] = useState<any>('')
    const [selectedEndDate, setSelectedEndDate] = useState<any>('')

    const history = useHistory()

    // Refatorar esses status/enums
    const I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE =
      activeSearchTypes.find((item: ActiveType) => {
        return item.type === 'I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE'
      })

    const SURGERY_ALREADY_DONE = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'SURGERY_ALREADY_DONE'
    })

    const SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL = activeSearchTypes.find(
      (item: ActiveType) => {
        return item.type === 'SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL'
      }
    )

    const I_NO_LONGER_WISH_TO_CONTINUE = activeSearchTypes.find(
      (item: ActiveType) => {
        return item.type === 'I_NO_LONGER_WISH_TO_CONTINUE'
      }
    )

    const CHANGE_OF_DOCTOR = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'CHANGE_OF_DOCTOR'
    })

    const HEALTH_PLAN_ANOTHER_HOSPITAL = activeSearchTypes.find(
      (item: ActiveType) => {
        return item.type === 'HEALTH_PLAN_ANOTHER_HOSPITAL'
      }
    )

    const PERSONAL_PROBLEM = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'PERSONAL_PROBLEM'
    })

    const HOSPITAL_RETURN = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'HOSPITAL_RETURN'
    })

    const OTHER = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'OTHER'
    })

    const OPERATOR_AUTHORIZED = activeSearchTypes.find((item: ActiveType) => {
      return item.type === 'OPERATOR_AUTHORIZED'
    })

    function getPercentual(value: number) {
      if (value && totalActiveSearchCount) {
        const percentual = (value / totalActiveSearchCount) * 100
        return percentual.toFixed(1) + '%'
      } else {
        return '0%'
      }
    }

    const handleRedirectToDataGrid = (params?: LoadActiveSearchProps) => {
      history.push('/busca-ativa/detalhes', {
        headerTitle: params?.headerTitle,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        type: params?.type,
        status: params?.status
      })
    }

    return (
      <>
        <HeadingNew size="xlarge" color="secondary700" lineHeight="xlarge">
          Motivos de não realização da cirurgia
        </HeadingNew>

        <DateRangeSelect
          loadActiveSearchStatistics={loadActiveSearchStatistics}
          setActiveSearchTypes={setActiveSearchTypes}
          setTotalActiveSearchCount={setTotalActiveSearchCount}
          setHelpCardInfo={setHelpCardInfo}
          setIsLoading={setIsLoading}
          setSelectedStartDate={setSelectedStartDate}
          setSelectedEndDate={setSelectedEndDate}
          handleRedirectToDataGrid={handleRedirectToDataGrid}
          currentHospitalId={currentHospitalId}
        />
        <S.Wrapper>
          <ReasonIndicatorCard
            title={
              ActiveSearchSurgeryTranslated.I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE
            }
            quantity={I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE?.count}
            percent={getPercentual(
              I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE?.count
            )}
            onSurgery
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle:
                  ActiveSearchSurgeryTranslated.I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE,
                type: ActiveSearchSurgeryType.I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.SURGERY_ALREADY_DONE}
            quantity={SURGERY_ALREADY_DONE?.count}
            percent={getPercentual(SURGERY_ALREADY_DONE?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.SURGERY_ALREADY_DONE,
                type: ActiveSearchSurgeryType.SURGERY_ALREADY_DONE
              })
            }
          />
          <ReasonIndicatorCard
            title={
              ActiveSearchSurgeryTranslated.SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL
            }
            quantity={SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL?.count}
            percent={getPercentual(
              SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL?.count
            )}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle:
                  ActiveSearchSurgeryTranslated.SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL,
                type: ActiveSearchSurgeryType.SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.I_NO_LONGER_WISH_TO_CONTINUE}
            quantity={I_NO_LONGER_WISH_TO_CONTINUE?.count}
            percent={getPercentual(I_NO_LONGER_WISH_TO_CONTINUE?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle:
                  ActiveSearchSurgeryTranslated.I_NO_LONGER_WISH_TO_CONTINUE,
                type: ActiveSearchSurgeryType.I_NO_LONGER_WISH_TO_CONTINUE
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.OPERATOR_AUTHORIZED}
            quantity={OPERATOR_AUTHORIZED?.count}
            percent={getPercentual(OPERATOR_AUTHORIZED?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.OPERATOR_AUTHORIZED,
                type: ActiveSearchSurgeryType.OPERATOR_AUTHORIZED
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.HOSPITAL_RETURN}
            quantity={HOSPITAL_RETURN?.count}
            percent={getPercentual(HOSPITAL_RETURN?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.HOSPITAL_RETURN,
                type: ActiveSearchSurgeryType.HOSPITAL_RETURN
              })
            }
          />
          <ReasonIndicatorCard
            title="Troquei de médico"
            quantity={CHANGE_OF_DOCTOR?.count}
            percent={getPercentual(CHANGE_OF_DOCTOR?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.CHANGE_OF_DOCTOR,
                type: ActiveSearchSurgeryType.CHANGE_OF_DOCTOR
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.HEALTH_PLAN_ANOTHER_HOSPITAL}
            quantity={HEALTH_PLAN_ANOTHER_HOSPITAL?.count}
            percent={getPercentual(HEALTH_PLAN_ANOTHER_HOSPITAL?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle:
                  ActiveSearchSurgeryTranslated.HEALTH_PLAN_ANOTHER_HOSPITAL,
                type: ActiveSearchSurgeryType.HEALTH_PLAN_ANOTHER_HOSPITAL
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.PERSONAL_PROBLEM}
            quantity={PERSONAL_PROBLEM?.count}
            percent={getPercentual(PERSONAL_PROBLEM?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.PERSONAL_PROBLEM,
                type: ActiveSearchSurgeryType.PERSONAL_PROBLEM
              })
            }
          />
          <ReasonIndicatorCard
            title={ActiveSearchSurgeryTranslated.OTHER}
            quantity={OTHER?.count}
            percent={getPercentual(OTHER?.count)}
            onSelect={() =>
              handleRedirectToDataGrid({
                headerTitle: ActiveSearchSurgeryTranslated.OTHER,
                type: ActiveSearchSurgeryType.OTHER
              })
            }
          />
        </S.Wrapper>

        <HelpRequestPanel
          helpCardInfo={helpCardInfo}
          handleRedirectToDataGrid={handleRedirectToDataGrid}
        />
      </>
    )
  }
)

type DateRangeSelectProps = {
  loadActiveSearchStatistics: LoadActiveSearchStatistics
  setIsLoading: (value: boolean) => void
  setActiveSearchTypes: (value: ActiveType[]) => void
  setTotalActiveSearchCount: (value: number) => void
  setHelpCardInfo: (value: HelpCardType) => void
  setSelectedStartDate: (value: string) => void
  setSelectedEndDate: (value: string) => void
  handleRedirectToDataGrid: (params?: LoadActiveSearchProps) => void
  currentHospitalId: number
}

const DateRangeSelect = ({
  loadActiveSearchStatistics,
  setIsLoading,
  setActiveSearchTypes,
  setTotalActiveSearchCount,
  setHelpCardInfo,
  setSelectedStartDate,
  setSelectedEndDate,
  handleRedirectToDataGrid,
  currentHospitalId
}: DateRangeSelectProps) => {
  const filters = {
    end: moment().utc().endOf('day').toISOString(),
    start: moment().utc().subtract('1', 'month').startOf('day').toISOString(),
    label: 'month'
  }

  const [showCalendar, setShowCalendar] = useState<'start' | 'end' | ''>()

  // Refatorar esses filtros
  const [dates, setDates] =
    useState<{ start?: string; end?: string; label?: string }>(filters)

  const toggleCalendar = (order: 'start' | 'end') => {
    if (showCalendar === order) {
      setShowCalendar('')
    } else {
      setShowCalendar(order)
    }
  }

  async function getInitialActiveSearch() {
    setIsLoading(true)

    const startDate = moment()
      .utc()
      .subtract('1', 'month')
      .startOf('day')
      .format('YYYY-MM-DD')
    const endDate = moment().format('YYYY-MM-DD')
    setSelectedStartDate(startDate)
    setSelectedEndDate(endDate)

    if (loadActiveSearchStatistics) {
      try {
        const response = await loadActiveSearchStatistics.load({
          startDate,
          endDate
        })

        setActiveSearchTypes(response?.type)
        setHelpCardInfo(response?.help_card)

        let sum = 0 as any
        response?.type?.forEach((item: ActiveType) => {
          sum += item.count
        })
        setTotalActiveSearchCount(sum)
      } catch (error) {
        toast.error('Ocorreu um erro ao realizar a busca ativa')
      } finally {
        setIsLoading(false)
      }
    }
  }

  const changeDate = (date: Date) => {
    if (showCalendar === 'start' && !moment(date).isSameOrBefore(dates.end)) {
      return setShowCalendar('')
    } else if (
      showCalendar === 'end' &&
      moment(dates[showCalendar]) &&
      !moment(date).isSameOrAfter(dates.start)
    ) {
      return setShowCalendar('')
    }

    if (showCalendar) {
      setDates({
        ...dates,
        [showCalendar]: date.toISOString(),
        label: 'personalized'
      })
      handleLoadActiveSearchStatistics({
        ...dates,
        [showCalendar]: date.toISOString(),
        label: 'personalized'
      })
    }
    return setShowCalendar('')
  }

  type DateSelectType = {
    start?: string
    end?: string
    label?: string
  }

  const changeInterval = (interval: string) => {
    const today = moment().tz('America/Sao_Paulo').utc()
    const dates: DateSelectType = {
      end: today.endOf('day').toISOString(),
      label: interval
    }

    switch (interval) {
      case 'today':
        dates.start = today.startOf('day').toISOString()
        break
      case 'yesterday':
        dates.start = today.subtract('1', 'days').startOf('day').toISOString()
        dates.end = today.endOf('day').toISOString()
        break
      case 'week':
        dates.start = today.subtract('1', 'week').startOf('day').toISOString()
        break
      case 'month':
        dates.start = today.subtract('1', 'month').startOf('day').toISOString()
        break
      case 'trimester':
        dates.start = today.subtract('3', 'month').startOf('day').toISOString()
        break
      case 'semester':
        dates.start = today.subtract('6', 'month').startOf('day').toISOString()
        break
      default:
        dates.start = today.toISOString()
        break
    }
    setDates(dates)
    handleLoadActiveSearchStatistics(dates)
  }

  const getFilterValue = () => {
    if (dates.label === 'personalized') {
      return ''
    }
    return dates.label
  }

  const filterValues = [
    {
      label: 'Hoje',
      value: 'today'
    },
    {
      label: 'Ontem',
      value: 'yesterday'
    },
    {
      label: 'Semana',
      value: 'week'
    },
    {
      label: 'Mês',
      value: 'month'
    },
    {
      label: 'Trimestre',
      value: 'trimester'
    },
    {
      label: 'Semestre',
      value: 'semester'
    }
  ]

  async function handleLoadActiveSearchStatistics(dates: DateSelectType) {
    setIsLoading(true)
    try {
      const startDate = moment(dates.start).format('YYYY-MM-DD')
      const endDate = moment(dates.end).format('YYYY-MM-DD')

      const response = await loadActiveSearchStatistics.load({
        startDate,
        endDate
      })

      setSelectedStartDate(startDate)
      setSelectedEndDate(endDate)

      setActiveSearchTypes(response?.type)
      setHelpCardInfo(response.help_card)
    } catch (error) {
      toast.error('Ocorreu um erro ao realizar a busca ativa')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getInitialActiveSearch()
  }, [currentHospitalId])

  return (
    <>
      <S.InputContainer>
        <SelectFieldNew
          label="Frequência"
          labelOverlapping
          labelColor="primary600"
          labelSize="xxsmall"
          labelWeight="semiBold"
          items={filterValues}
          onInputChange={changeInterval}
          name="period_filter"
          placeholder={getFilterValue() ? 'Selecionar' : 'Personalizado'}
          value={getFilterValue()}
        />
        <S.InputCalendar show={showCalendar === 'start'}>
          <TextFieldNew
            label="Data início"
            labelOverlapping
            labelColor="primary600"
            labelSize="xxsmall"
            labelWeight="semiBold"
            mask={dateMask}
            icon={<CalendarRange />}
            iconIsButton
            iconPosition="insideRight"
            onIconClick={() => toggleCalendar('start')}
            value={dateInputFormat(moment(dates.start ?? '').toISOString())}
          />
          <S.StyledCalendar
            show={showCalendar === 'start'}
            onDateChange={(date: any) => changeDate(date as Date)}
          />
        </S.InputCalendar>

        <S.InputCalendar show={showCalendar === 'start'}>
          <TextFieldNew
            label="Data fim"
            labelOverlapping
            labelColor="primary600"
            labelSize="xxsmall"
            labelWeight="semiBold"
            mask={dateMask}
            icon={<CalendarRange />}
            iconIsButton
            iconPosition="insideRight"
            onIconClick={() => toggleCalendar('end')}
            value={dateInputFormat(
              moment(dates.end ?? '')
                .subtract(4, 'hours')
                .toISOString()
            )}
          />
          <S.StyledCalendar
            show={showCalendar === 'end'}
            onDateChange={(date: any) => changeDate(date as Date)}
          />
        </S.InputCalendar>
        <ButtonNew size="large" onClick={() => handleRedirectToDataGrid()}>
          Ver todos os motivos
        </ButtonNew>
      </S.InputContainer>
    </>
  )
}

type HelpCardPanelProps = {
  helpCardInfo: HelpCardType
  handleRedirectToDataGrid: (params?: LoadActiveSearchProps) => void
}
const HelpRequestPanel = ({
  helpCardInfo,
  handleRedirectToDataGrid
}: HelpCardPanelProps) => {
  return (
    <>
      <HeadingNew
        size="xlarge"
        color="secondary700"
        lineHeight="xlarge"
        style={{ marginBottom: '16px' }}
      >
        Solicitações de ajuda
      </HeadingNew>
      <HelpRequestsIndicators
        helpCardInfo={helpCardInfo}
        handleRedirectToDataGrid={handleRedirectToDataGrid}
      />
    </>
  )
}

export default ActiveSearchLayout
